import { render, staticRenderFns } from "./QuestionnaireSummary.vue?vue&type=template&id=45af5925&scoped=true"
import script from "./QuestionnaireSummary.vue?vue&type=script&lang=js"
export * from "./QuestionnaireSummary.vue?vue&type=script&lang=js"
import style0 from "./QuestionnaireSummary.vue?vue&type=style&index=0&id=45af5925&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45af5925",
  null
  
)

export default component.exports